export const TaskStatus = {
  initiated: 'initiated',
  updating: 'updating',
  completed: 'completed',
  failed: 'failed'
}

export const TaskCompletionStatus = {
  NotCompleted: 'NotCompleted',
  NotStarted: 'NotStarted',
  Completed: 'Completed'
}


// WEBPACK FOOTER //
// ./src/constants/tasks.js